import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { Fragment, useEffect, useState } from 'react';

import { CommonHead } from '@app/components/CommonHead';
import SideMenuComponent from '@app/components/dashboard/SideMenuComponent';
import BellIcon from '@app/components/icons/BellIcon';
import { useToast } from '@app/components/ui';
import ScreenType from '@app/components/ui/ScreenType';
import { AuthState, useAuth } from '@app/hooks/useAuth';
import { NavigationItem, useCommonData } from '@app/hooks/useCommonData';
import { DashboardProvider } from '@app/hooks/useDashboard';

interface DevLayoutProps {
  children: React.ReactNode;
}

const DevLayout: React.FC<DevLayoutProps> = ({ children }) => {
  const {
    website,
    navigation: { subfooter },
  } = useCommonData();
  const { isAuth, isLoggedOut } = useAuth();
  const router = useRouter();
  const toast = useToast();
  const [sidebar] = useState<NavigationItem[]>([
    { label: 'Test Notifications', href: '/test/notifications', icon: <BellIcon size={24} /> },
  ]);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      router.push('/dashboard');
    }
  }, []);

  useEffect(() => {
    if (isAuth === AuthState.UNAUTH && !isLoggedOut) {
      toast.error('Vui lòng đăng nhập để truy cập trang này');
      sessionStorage.setItem('returnUrl', router.asPath);
      router.push('/auth/login');
    }
  }, [isAuth]);

  return (
    <DashboardProvider>
      <CommonHead />

      <div className="h-screen bg-gray-50 px-5 overflow-hidden flex gap-5">
        <ScreenType />
        <div className="shrink-1 py-5">
          <SideMenuComponent className="shrink-1" sidebar={sidebar} />
        </div>
        <div className="flex-1 flex flex-col py-5 overflow-hidden">
          <main className="flex-1 overflow-hidden text-gray-800">
            <div className="flex flex-col overflow-y-auto min-h-full max-h-full scrollbar-thin">
              <div className="flex flex-col gap-4 grow">{children}</div>
            </div>
          </main>
          <footer className="shrink-1 flex text-xs text-gray-800 justify-between pt-3">
            <div>
              © {new Date().getFullYear()} {website.name}. All rights reserved.
            </div>
            <ul className="flex gap-2 items-center flex-nowrap">
              {subfooter.map((item: any, index: number, array: any[]) => (
                <Fragment key={item.label}>
                  <li>
                    <Link
                      href={item.href}
                      className="border-b border-transparent hover:border-gray-900  transition-all cursor-pointer"
                    >
                      <span dangerouslySetInnerHTML={{ __html: item.label }} />
                    </Link>
                  </li>
                  {index !== array.length - 1 && <li className="text-gray-500">&#9670;</li>}
                </Fragment>
              ))}
            </ul>
          </footer>
        </div>
      </div>
    </DashboardProvider>
  );
};

export default DevLayout;
